import type {PermissionsRecordType} from '../permissions';

export const vehicleFinancingTemplatePermissions = {
  readVehicleFinancingTemplate: {
    resourceId: 'VEHICLE_FINANCING_TEMPLATE',
    actionId: 'READ',
    scopes: [],
  },
  createVehicleFinancingTemplate: {
    resourceId: 'VEHICLE_FINANCING_TEMPLATE',
    actionId: 'CREATE',
    scopes: [],
  },
  updateVehicleFinancingTemplate: {
    resourceId: 'VEHICLE_FINANCING_TEMPLATE',
    actionId: 'UPDATE',
    scopes: [],
  },
  cloneVehicleFinancingTemplate: {
    resourceId: 'VEHICLE_FINANCING_TEMPLATE',
    actionId: 'CLONE',
    scopes: [],
  },
  archiveVehicleFinancingTemplate: {
    resourceId: 'VEHICLE_FINANCING_TEMPLATE',
    actionId: 'ARCHIVE',
    scopes: [],
  },
  restoreVehicleFinancingTemplate: {
    resourceId: 'VEHICLE_FINANCING_TEMPLATE',
    actionId: 'RESTORE',
    scopes: [],
  },
  deleteVehicleFinancingTemplate: {
    resourceId: 'VEHICLE_FINANCING_TEMPLATE',
    actionId: 'DELETE',
    scopes: [],
  },
  reorderAutomaticVehicleFinancingTemplates: {
    resourceId: 'VEHICLE_FINANCING_TEMPLATE',
    actionId: 'REORDER_AUTOMATIC',
    scopes: [],
  },
} satisfies PermissionsRecordType;
